var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ActionTypes from '../actionTypes';
import { toEntityIdsList, toEntityMapById } from '../../shared/functions';
var initialState = {};
/**
 * Derives the next "newsGroups" state from the previous one and the current action.
 */
var newsGroupsReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.DERIVE_NEWSGROUPS:
            return (__assign(__assign({}, state), { ids: toEntityIdsList(action.payload), entities: toEntityMapById(action.payload) }));
        default:
            return state;
    }
};
export default newsGroupsReducer;
